<template>
  <div class="subscription-container mx-0">
    <loading :active.sync="is_loading"></loading>
    <a v-if="!allSubscriptions" href="#" style="cursor:pointer;" @click="showAllSubscriptions">
      <h5 class="pt-0 pb-3 pt-3"> <span class="customLoader" v-show="loaderAllSuscriptions === true"></span>Ver todas tus suscripciones</h5>
    </a>
    <a v-if="allSubscriptions" href="#" style="cursor:pointer;" @click="viewLastSubscription">
      <h5 class="pt-0 pb-3 pt-3 text-fixed">Ver suscripcion mas reciente</h5>
    </a>
    <b-card title="Suscripción reciente:" class="mb-2" id="suscripciones" v-if="!allSubscriptions"
          :style="checkProduct(suscripcion)">
      <b-card-text class="pt-4">{{ suscripcion.type.description }}</b-card-text>
      <b-card-text
        >Periodo: {{ suscripcion.type.period_description }}</b-card-text
      >
      <b-card-text v-if="suscripcion.payment.payment_status_id == 2"
        >Fecha de inicio: {{ suscripcion.start_date }}</b-card-text
      >
      <b-card-text v-if="suscripcion.payment.payment_status_id == 2"
        >Fecha de termino: {{ suscripcion.end_date }}</b-card-text
      >
      <b-alert v-if="is_renewed" show variant="success"
        >Suscripción Renovada</b-alert
      >
      <b-alert
        style="margin-top: 155px; padding: 10px 0; border: 3px solid #8b6b0e;"
        show
        variant="warning"
        v-if="suscripcion.payment.payment_status_id == 1 && !is_renewed"
        >Pago Pendiente</b-alert
      >
        <b-alert
            style="margin-top: 155px; padding: 10px 0; border: 3px solid #8b6b0e;"
            show
            variant="danger"
            v-if="suscripcion.payment.payment_status_id == 3 && !is_renewed"
        >Pago Cancelado</b-alert
        >
      <b-alert
        show
        variant="danger"
        v-if="suscripcion.end_date < actualDate && !is_renewed"
        >Suscripción Vencida</b-alert
      >
      <b-card-text
        v-if="
          !is_renewed &&
          suscripcion.payment.payment_status_id == 2 &&
          suscripcion.end_date >= actualDate
        "
        >Suscripción Activa</b-card-text
      >
      <button
        v-if="suscripcion.is_active === 1 && suscripcion.is_recurrent === true"
        class="btn text-light mt-4"
        style="width: 100%; height: auto; background: #0f182b"
        @click="setIdSubscription(suscripcion.id, $event)"
      >
        Cancelar suscripción recurrente
      </button>
      <button
        v-if="suscripcion.is_active === 1 && suscripcion.is_recurrent === false && suscripcion.payment.payment_status_id == 2"
        class="btn text-light mt-4"
        style="width: 120px; height: 45px; background: #0f182b; margin-bottom: 15px;"
        @click="loadProduct"
      >
        Renovar
      </button>
      <a href="#" style="cursor:pointer;" data-toggle="modal" data-target="#suscripcionReciente">
        <h5 class="pb-0 pt-5">Ver más...</h5>
      </a>
     <!-- MODAL -->
     <div class="modal fade" id="suscripcionReciente" tabindex="-1" role="dialog" aria-labelledby="suscripcionReciente" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header" style="background: #0f182b;">
                  <h5 class="modal-title" id="exampleModalLongTitle"> 
                    <img src="images/img_estilos/MMK_Logo.png" style="height: 30px; width:100%; object-fit:contain; cursor:pointer;" alt="logo"/>
                  </h5>
                  <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="pb-5">
                    <h3>Información de tu suscripción</h3>
                  </div>
                  <div class="row mx-auto text-center">
                    <div class="p-3 col-12 col-md-4">
                      <p v-if="suscripcion.receiver_name === null"><strong class="d-block">Nombre del Suscriptor:</strong>{{userName}} {{userLastName}} </p>
                      <p v-else><strong class="d-block">Nombre del Suscriptor:</strong> {{suscripcion.receiver_name}}</p>
                    </div>
                    <div class="p-3 col-12 col-md-4">
                      <p><strong class="d-block">Suscrito a:</strong> {{suscripcion.type.description}}</p>
                    </div>
                    <div class="p-3 col-12 col-md-4">
                      <p><strong class="d-block">Estatus de la suscripción:</strong> {{suscripcion.status.description}}
                        <span v-show="suscripcion.subscription_status_id === 1" class="statusSubscription"  type="active"></span>
                        <span v-show="suscripcion.subscription_status_id === 3" class="statusSubscription"  type="pendiente"></span>
                      </p>
                    </div>
                    <div class="p-3 col-12">
                      <p><strong class="mb-3">Periodo de la suscripción: </strong>{{suscripcion.type.period_description}}</p>
                      <div class="row mx-auto border border-success rounded mt-3">
                        <div class="p-3 col-12 col-md-4">
                          <p><strong class="d-block">Fecha de inicio:</strong> {{suscripcion.start_date}}</p>
                        </div>
                        <div class="p-3 col-12 col-md-4">
                          <p><strong class="d-block">Fecha de fin:</strong> {{suscripcion.end_date}}</p>
                        </div>
                        <div class="p-3 col-12 col-md-4">
                          <p><strong class="d-block">Fecha de renovación:</strong> {{suscripcion.renewal_date}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="p-3 col-12">
                      <p><strong class="mb-3">Dirección asociada a la suscripción:</strong></p>
                      <div class="row mx-auto border border-info rounded mt-3">
                        <div class="p-3 col-12 col-md-12">
                          <p><strong class="d-block"></strong>{{suscripcion.address.municipality}} , 
                            {{suscripcion.address.suburb}} ,
                            calle {{suscripcion.address.street}},
                            lote {{suscripcion.address.no_int}},
                            CP {{suscripcion.address.cp}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN MODAL -->
    </b-card>
        
    <b-card title="Tus Suscripciones" class="mb-2 py-3" id="suscripciones" v-else >
      <div class="custom-card col-10 col-sm-8 col-md-4 col-lg-3 card m-4 py-4 d-inline-flex" 
        v-for="(subscription, index) in subscriptions" :key="index"
        :style="checkProduct(subscription)">
        <div>
        <b-card-text>{{ subscription.type.description }}</b-card-text>
          <b-card-text
            >Periodo: {{ subscription.type.period_description }}</b-card-text
          >
          <b-card-text v-if="subscription.payment.payment_status_id == 2"
            >Fecha de inicio: {{ subscription.start_date }}</b-card-text
          >
          <b-card-text v-if="subscription.payment.payment_status_id == 2"
            >Fecha de termino: {{ subscription.end_date }}</b-card-text
          >
          <b-alert v-if="is_renewed" show variant="success"
            >Suscripción Renovada</b-alert
          >
          <b-alert
            style="margin-top: 155px; padding: 10px 0; border: 3px solid #8b6b0e;"
            show
            variant="warning"
            v-if="subscription.payment.payment_status_id == 1 && !is_renewed"
            >Pago Pendiente</b-alert
          >
            <b-alert
                style="margin-top: 155px; padding: 10px 0; border: 3px solid #8b6b0e;"
                show
                variant="danger"
                v-if="subscription.payment.payment_status_id == 3 && !is_renewed"
            >Pago Cancelado</b-alert
            >
          <b-alert
            show
            variant="danger"
            v-if="subscription.end_date < actualDate && !is_renewed"
            >Suscripción Vencida</b-alert
          >
          <b-card-text
            v-if="
              !is_renewed &&
              subscription.payment.payment_status_id == 2 &&
              subscription.end_date >= actualDate
            "
            >Suscripción Activa</b-card-text
          >
          <button
            v-if="subscription.is_active === 1 && subscription.is_recurrent === true"
            class="btn text-light mt-4"
            style="width: 100%; height: auto; background: #0f182b"
            @click="setIdSubscription(subscription.id, $event)"
          >
            Cancelar suscripción recurrente
          </button>

          <button
            v-if="subscription.is_active === 1 && subscription.is_recurrent === false && subscription.payment.payment_status_id == 2 && (subscription.product_id != 41 && subscription.product_id != 80)"
            class="btn text-light mt-4"
            style="width: 120px; height: 45px; background: #0f182b; margin-bottom: 15px;"
            @click="loadProduct"
          >
            Renovar
          </button>
          <a href="#" style="cursor:pointer;" data-toggle="modal" class="linkModal" :data-target="'#'+index">
            <h5 class="pb-0 pt-5">Ver más...</h5>
          </a>
          </div>
          <!-- MODAL -->
          <div class="modal fade" :id="index" tabindex="-1" role="dialog" :aria-labelledby="index" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header" style="background: #0f182b;">
                  <h5 class="modal-title" id="exampleModalLongTitle"> 
                    <img src="images/img_estilos/MMK_Logo.png" style="height: 30px; width:100%; object-fit:contain; cursor:pointer;" alt="logo"/>
                  </h5>
                  <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="pb-5">
                    <h3>Información de tu suscripción</h3>
                  </div>
                  <div class="row mx-auto text-center">
                    <div class="p-3 col-12 col-md-4">
                      <p v-if="suscripcion.receiver_name === null"><strong class="d-block">Nombre del Suscriptor:</strong>{{userName}} {{userLastName}} </p>
                      <p v-else><strong class="d-block">Nombre del Suscriptor:</strong> {{suscripcion.receiver_name}}</p>
                    </div>
                    <div class="p-3 col-12 col-md-4">
                      <p><strong class="d-block">Suscrito a:</strong> {{subscription.type.description}}</p>
                    </div>
                    <div class="p-3 col-12 col-md-4">
                      <p><strong class="d-block">Estatus de la suscripción:</strong> {{subscription.status.description}}
                        <span v-show="subscription.subscription_status_id === 1" class="statusSubscription"  type="active"></span>
                        <span v-show="subscription.subscription_status_id === 3" class="statusSubscription"  type="pendiente"></span>
                      </p>
                    </div>
                    <div class="p-3 col-12">
                      <p><strong class="mb-3">Periodo de la suscripción: </strong>{{subscription.type.period_description}}</p>
                      <div class="row border border-success rounded mt-3">
                        <div class="p-3 col-12 col-md-4">
                          <p><strong class="d-block">Fecha de inicio:</strong> {{subscription.start_date}}</p>
                        </div>
                        <div class="p-3 col-12 col-md-4">
                          <p><strong class="d-block">Fecha de fin:</strong> {{subscription.end_date}}</p>
                        </div>
                        <div class="p-3 col-12 col-md-4">
                          <p><strong class="d-block">Fecha de renovación:</strong> {{subscription.renewal_date}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="p-3 col-12">
                      <p><strong class="mb-3">Dirección asociada a la suscripción:</strong></p>
                      <div class="row border border-info rounded mt-3">
                        <div class="p-3 col-12 col-md-12">
                          <p><strong class="d-block"></strong>{{subscription.address.municipality}} , 
                            {{subscription.address.suburb}} ,
                            calle {{subscription.address.street}},
                            lote {{subscription.address.no_int}},
                            CP {{subscription.address.cp}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN MODAL -->
      </div>
    </b-card>
    
  
    <small
        >Al renovar anticipadamente se abonarán los meses solicitados a tu
        suscripción actual</small
      >
      <b-modal 
        id="modal-cancelSubscription" 
        title="Suscripciones"
        @ok="confirmCancelSubs"
        @cancel="cancelSubs(1)"
        @hide="cancelSubs(2)"
        cancel-title="Mantener Suscripción"
        cancel-variant="primary"
        ok-title="Cancelar"
        ok-variant="secondary"
        footer-class="d-flex justify-content-center"
        >
        <!-- <div class="bg-white">
          <img loading="lazy" src="images/aviso_cancelacion_suscripcion.png" alt="Cancelación Suscripción" class="img-fluid" height="auto" style="max-width:634px; width:100%; height:auto; margin:auto; display:block;">
        </div> -->
      </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
const axios = require("axios");

export default {
  name: "Subscription",
  props: ["suscripcionComponente", "renovacionesComponente", "userName", "userLastName"],
  components: {
    Loading,
  },
  data() {
    return {
      suscripcion: this.suscripcionComponente,
      actualDate: "",
      alertDate: "",
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
      productCart: {
        id: null,
        item_name: null,
        item_description: null,
        quantity: 1,
        attribute: null,
        price: 0,
        priceObj: null,
        delight: null,
        previous: null,
        is_renew: false,
        is_recurrency: true
      },
      productImage: "",
      productPrice: 0,
      prices: null,
      is_subscription: false,
      attributes: [],
      attributeSelected: "",
      haveAttributesFilter: true,
      is_loading: false,
      is_renewed: false,
      idCancelS: null,
      subscriptions: [],
      sus_renew: [],
      allSubscriptions: false,
      loaderAllSuscriptions: false,
    };
  },
  created() {
    document.querySelector('#flexArea').classList = "col col-md-6 col-lg-5";
    // Convertir Date a formato que manda backend
    const date = new Date();
    const dateString = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    )
      .toISOString()
      .split("T")[0];

    this.actualDate = dateString;

    // renew button 60 days before
    let alertDate = new Date();
    alertDate.setDate(alertDate.getDate() + 60);

    const dateStringAlert = new Date(
      alertDate.getTime() - alertDate.getTimezoneOffset() * 60000
    )
      .toISOString()
      .split("T")[0];

    this.alertDate = dateStringAlert;

    this.renovacionesComponente.forEach((renovacion) => {
      if (renovacion.previous_sus === this.suscripcionComponente.id) {
        this.is_renewed = true;
      }
    });
  },
  methods: {
    loadProduct: function () {
      this.is_loading = true;
      if ($cookies.get("ctoken")) {
        console.info("Se busca obtener el producto");
        axios({
          method: "GET",
          url: this.api_url + "/products/" + 1,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("ctoken"),
          },
        })
          .then((response) => {
            // console.log(response.data.data);
            this.loadPrices(response.data.data);
            // Cargando datos al producto para carrito
            this.productCart.id = response.data.data.id;
            this.productCart.item_name = response.data.data.name;
            this.productCart.item_description = response.data.data.description;
            this.productCart.previous = this.suscripcionComponente.id;

            if (this.suscripcion.end_date < this.actualDate) {
              this.productCart.is_renew = true;
            }
            this.is_loading = false;

            this.addToCart();
          })
          .catch((error) => {
            console.error(error);
            this.is_loading = false;
          });
      } else {
        console.info("No se encontro la cookie");
        this.is_loading = false;
      }
    },
    loadPrices: function (product) {
      this.prices = product.prices;

      // Validar tipo de suscripcion para el precio
      if (this.suscripcionComponente.subscription_type_id === 3) {
        this.productCart.price = this.prices[1].price;
        this.productCart.priceObj = this.prices[1];
        this.productPrice = this.prices[1];
      } else {
        this.productCart.price = this.prices[0].price;
        this.productCart.priceObj = this.prices[0];
        this.productPrice = this.prices[0];
      }
    },
    addToCart: function () {
      // console.log(this.productCart);
      //this.$store.commit("addProductCart", this.productCart);
      this.$store.commit('addProductCartSubscription', this.productCart);
      //this.$router.push({ name: "checkout" });
      this.$router.push({name: "checkoutSubscription", params: this.productCart});
    },
    setIdSubscription: function(idSubscription, e){
      this.idCancelS = idSubscription;
      this.$bvModal.show("modal-cancelSubscription");
    },
    confirmCancelSubs: function(){
        console.log('Petición para cancelar suscripcion');

        axios({
          method: "POST",
          url: this.api_url + "/payment/cancel-subscription",
          data:{
            subscription_id: this.idCancelS
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("ctoken"),
          },
        })
        .then((response) => {
          if(response.data.status){
            console.log('Respuesta de suscripcion cancelada: ', response.data);
            this.idCancelS = null;
            this.$snotify.error(response.data.message);
            this.showAllSubscriptions();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    cancelSubs: function (param){
      if(param === 1){
        this.$bvModal.hide("modal-cancelSubscription");
        this.idCancelS = null;
        console.log('seguir con la suscripcion');
      }
      else{
        return false;
      }
    },
    showAllSubscriptions: function(){
      this.loaderAllSuscriptions = true;
      axios({
        method: "GET",
        url:
          this.api_url +
          "/subscribers/" +
          $cookies.get("uidmmkg") +
          "/subscriptions" + "?v=" + Math.floor(Date.now() / 1000),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
      .then((response) => {
        this.loaderAllSuscriptions = false;
        console.log("todas las suscripciones: ",response.data);
        this.subscriptions = response.data.data;

        this.subscriptions.forEach((sus) => {
          // Validar si existe una renovacion
          if (sus.is_renewed === 1) {
            this.sus_renew.push(sus);
          }
        });
        this.allSubscriptions = true;
        document.querySelector('#flexArea').classList = "col-12 p-0";
      })
      .catch((error) => {
        console.error(error);
      });
    },
    viewLastSubscription:function(){
      this.allSubscriptions = false;
      document.querySelector('#flexArea').classList = "col col-md-6 col-lg-5";
    },
    checkProduct: function(suscription){
      if(suscription.payment.payment_status_id == 1 && !this.is_renewed){
        return {border: '1px solid #e7af0b'};
      }
      else if(suscription.payment.payment_status_id == 3 && !this.is_renewed){
        return {border: '1px solid #f04150'};
      }
      else{
        return {border: '1px solid rgba(0, 0, 0, 0.125)'};
      }
    }
  },
};
</script>

<style scoped>
.subscription-container {
  margin: 35px;
}
.row{
  width:100%;
}
.custom-card{
  min-height: 440px;
}
.text-fixed{
  position: fixed;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, 0px);
  background-color: #0f182b;
  z-index: 10000;
  width: 100%;
  height: 70px;
  margin-bottom: 0;
  color:#ffffff;
}
.btnShowMore {
    position: absolute;
    bottom: -15px;
    top: auto;
    left: 50%;
    transform: translate(-50%,0);
    font-weight: 500;
    width: auto;
    letter-spacing: initial;
}
.customLoader {
    margin-right: 10px;
    width: 25px;
    height: 25px;
    border: 4px solid #f04150;
    vertical-align: bottom;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-animation: rotation-data-v-3a99e293 1s linear infinite;
    animation: rotation-data-v-3a99e293 1s linear infinite;
}
    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 
  .headerBodyModal{
    filter: invert(1);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .statusSubscription{
    right: auto;
    top: auto;
    margin-left: 5px;
    margin-top: 0px;
    position: absolute;
    vertical-align: middle;
    width: 10px;
    height: 10px;
    border-radius: 50%;
}
  .statusSubscription::before,
.statusSubscription::after {
  left: 0;
  top: 50%;
  margin-left: -1px;
  margin-top: -6px;
  position: absolute;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.statusSubscription[type="active"],
.statusSubscription[type="active"]::before,
.statusSubscription[type="active"]::after {
  background: #2ECC71;
}
.statusSubscription[type="cancelada"],
.statusSubscription[type="cancelada"]::before,
.statusSubscription[type="cancelada"]::after {
  background: #f04150;
}
.statusSubscription[type="pendiente"],
.statusSubscription[type="pendiente"]::before,
.statusSubscription[type="pendiente"]::after {
  background: #F1C40F;
}
.statusSubscription[type="inactiva"],
.statusSubscription[type="inactiva"]::before,
.statusSubscription[type="inactiva"]::after {
  background: gray;
}

.statusSubscription::before {
  content: "";
  animation: bounce 1.5s infinite;
}
.statusSubscription::after {
  content: "";
  animation: bounce 1.5s -0.4s infinite;
}

@keyframes bounce {
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    -webkit-transform: scale(2);
    opacity: 0;
  }
}

@-webkit-keyframes bounce {
  0% {
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    -webkit-transform: scale(2);
    opacity: 0;
  }
}
.linkModal{
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%,0);
}
</style>